<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import UserList from "../components/pages/todo-list/user.vue";
import ReadyToFilmList from "../components/pages/todo-list/ready-to-film.vue";
import CompleteMeList from "../components/pages/todo-list/complete-me.vue";
import ClipList from "../components/pages/todo-list/clip-list.vue";
import PostProdList from "../components/pages/todo-list/post-prod.vue";
import PublishList from "../components/pages/todo-list/publish.vue";
import ScriptModal from "../components/script-builder/Modal.vue";
import NotesModalList from "../components/notes/NotesModalList.vue";

export default {
  components: {
    UserList,
    ReadyToFilmList,
    CompleteMeList,
    ClipList,
    PostProdList,
    PublishList,
    ScriptModal,
    NotesModalList,
  },
  name: "Todo",
  data() {
    return {
      activityData: {},
      tabIndex: 0,
      tabs: [
        "activities",
        "ready-to-film",
        "clip-listed",
        "filmed",
        "post-production",
        "produced",
        "published",
      ],
    };
  },
};
</script>
<style lang="scss">
.data-listing-tabs {
  .tabs {
    .card-header {
      .card-header-tabs {
        li {
          width: auto;
          a {
            padding-left: 25px;
            padding-right: 25px;
            border-bottom: 0 !important;
            background: #efefef;
            text-transform: capitalize;
            &.active {
              border-bottom: 0 !important;
            }
          }
        }
      }
    }
  }
}
.todo-list {
  .b-table-sticky-header {
    max-height: calc(100vh - 410px);
    overflow: auto;
  }
}
</style>>

<template>
  <div>
    <b-card no-body class="data-listing-tabs todo-list">
      <b-tabs card v-model="tabIndex">
        <b-tab title="Naz" active>
          <user-list> </user-list>
        </b-tab>
        <b-tab title="Ready to film">
          <ready-to-film-list> </ready-to-film-list>
        </b-tab>
        <b-tab title="Clip List">
          <clip-list> </clip-list>
        </b-tab>
        <b-tab title="Complete Me">
          <complete-me-list> </complete-me-list>
        </b-tab>
        <b-tab title="Post Prod">
          <post-prod-list> </post-prod-list>
        </b-tab>
        <b-tab title="Publish">
          <publish-list> </publish-list>
        </b-tab>
      </b-tabs>
    </b-card>
    <script-modal></script-modal>

    <notes-modal-list> </notes-modal-list>
  </div>
</template>
